var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isScrolled
    ? _c("div", { staticClass: "pc-product-floating-sticky-info pl-5" }, [
        _c(
          "div",
          {
            staticClass:
              "floating-info-container d-flex align-items-center justify-content-between p-1"
          },
          [
            (_vm.selectedProduct && _vm.selectedProduct.sellingStyleName) ||
            (_vm.productData && _vm.productData.sellingStyleName)
              ? _c(
                  "h1",
                  {
                    staticClass:
                      "secondary-heading mb-0 heading-line-height font-weight-bold"
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.isRug
                            ? _vm.selectedProduct.sellingStyleName
                            : _vm.productData.sellingStyleName
                        ) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sellingStyleNumber
              ? _c("p", { staticClass: "color-light-grey mb-0 ml-3" }, [
                  _vm._v(_vm._s(_vm.sellingStyleNumber))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0 ml-3" }, [
              _vm._v(
                _vm._s(
                  _vm.getImperialDisplayValue
                    ? _vm.getImperialDisplayValue
                    : _vm.selectedProduct.productSizeImperial
                )
              )
            ]),
            _vm._v(" "),
            _vm.collectionRedirect ||
            (_vm.productData && _vm.productData.collectionCode)
              ? _c("div", { staticClass: "px-2 text-uppercase ml-3" }, [
                  _c(
                    "a",
                    {
                      staticClass: "collection-link",
                      attrs: {
                        href: _vm.collectionRedirect
                          ? _vm.collectionRedirect
                          : "/product-collection/" +
                            _vm.getCollectionLink(
                              _vm.productData.collectionCode.description,
                              _vm.productData.collectionCode.code
                            )
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.productData.collectionCode.description) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }